import lt from 'lodash/lt';
import lte from 'lodash/lte';
import gte from 'lodash/gte';

export const inRange = (value, min, max, inclusive = false) => {
  const lComparing = inclusive ? lte : lt;
  return gte(value || 0, min || -Infinity) && lComparing(value || 0, max || +Infinity);
};
